import React from 'react'
import _ from 'lodash'

import {
  DetailList,
  Col,
  Row,
  Badge,
  Link,
  ContentSection,
  ContentSectionBlock
} from 'camino-react'

const NoServiceCategoriesContent = ({ editTicketTypePath }) => (
  <React.Fragment>
    <p>
        This ticket type can use all service categories.
    </p>
    <p>
        To specify the service categories click
      {' '}
      <Link href={editTicketTypePath}>
          here
      </Link>
      {' '}
        and add service categories to this ticket type.
    </p>
  </React.Fragment>
)

class TicketTypeShow extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}
    this.serviceCategoryList = this.serviceCategoryList.bind(this)
  }

  serviceCategoryList () {
    const { ticketType, editTicketTypePath } = this.props

    if (_.isEmpty(ticketType.service_categories)) {
      return (<NoServiceCategoriesContent editTicketTypePath={editTicketTypePath} />)
    }

    return (
      <ul className="details-list list--no-list-style flex flex--wrap">
        {_.map(_.groupBy(ticketType.service_categories, 'parent_name'), (serviceCategories, parentName) => {
          if (parentName === 'null') {
            return null
          }

          return (
            <DetailList
              list={[{
                title: parentName,
                content: _.map(serviceCategories, ({ name }) => name)
              }]}
            />
          )
        })}
      </ul>
    )
  }

  render () {
    const {
      ticketType,
      editTicketTypePath
    } = this.props

    return (
      <Row>
        <Col>
          <ContentSection>
            <ContentSectionBlock title="Service Categories">
              {this.serviceCategoryList()}
            </ContentSectionBlock>
          </ContentSection>
        </Col>

        <Col>
          <ContentSection card>
            <ContentSectionBlock
              title="Information"
              actions={[{ text: 'Edit', href: editTicketTypePath }]}
            >
              <DetailList
                list={[
                  {
                    title: 'Internal',
                    content: _.isBoolean(ticketType.internal) ? (
                      <Badge
                        color={ticketType.internal ? 'green-bright' : 'red-bright'}
                      >
                        {ticketType.internal.toString()}
                      </Badge>
                    ) : ticketType.internal
                  },
                  {
                    title: 'Description',
                    content: ticketType.description
                  }
                ]}
              />
            </ContentSectionBlock>
          </ContentSection>
        </Col>
      </Row>
    )
  }
}

export default TicketTypeShow
